/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TransactionCreateRequest } from '../models/TransactionCreateRequest';
import type { TransactionListResponse } from '../models/TransactionListResponse';
import type { TransactionResponse } from '../models/TransactionResponse';
import type { TransactionSummaryResponse } from '../models/TransactionSummaryResponse';
import type { TransactionType } from '../models/TransactionType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TransactionsService {
    /**
     * Create transaction
     * Create transaction and update user balance atomically
     * @returns TransactionResponse Successful Response
     * @throws ApiError
     */
    public static createTransactionApiTransactionsPost({
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        requestBody: TransactionCreateRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<TransactionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/transactions',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `User or transaction not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get user transaction history
     * Get paginated transaction history sorted by creation date
     * @returns TransactionListResponse Successful Response
     * @throws ApiError
     */
    public static getUserTransactionsApiTransactionsUserIdGet({
        userId,
        offset,
        limit = 20,
        transactionType,
        dateFrom,
        dateTo,
        xServiceToken,
        xApiKey,
        session,
    }: {
        userId: number,
        /**
         * Pagination offset
         */
        offset?: number,
        /**
         * Maximum number of transactions to return
         */
        limit?: number,
        /**
         * Filter by transaction type
         */
        transactionType?: (TransactionType | null),
        /**
         * Start date filter (ISO format)
         */
        dateFrom?: (string | null),
        /**
         * End date filter (ISO format)
         */
        dateTo?: (string | null),
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<TransactionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transactions/{user_id}',
            path: {
                'user_id': userId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'transaction_type': transactionType,
                'date_from': dateFrom,
                'date_to': dateTo,
            },
            errors: {
                400: `Validation error`,
                404: `User or transaction not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get user balance
     * Get current balance within 200ms using cached data
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getUserBalanceApiTransactionsUserTelegramIdBalanceGet({
        telegramId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transactions/user/{telegram_id}/balance',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `User or transaction not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get transaction summary
     * Get transaction summary statistics for a user
     * @returns TransactionSummaryResponse Successful Response
     * @throws ApiError
     */
    public static getTransactionSummaryApiTransactionsSummaryUserIdGet({
        userId,
        dateFrom,
        dateTo,
        xServiceToken,
        xApiKey,
        session,
    }: {
        userId: number,
        /**
         * Start date filter (ISO format)
         */
        dateFrom?: (string | null),
        /**
         * End date filter (ISO format)
         */
        dateTo?: (string | null),
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<TransactionSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transactions/summary/{user_id}',
            path: {
                'user_id': userId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            query: {
                'date_from': dateFrom,
                'date_to': dateTo,
            },
            errors: {
                400: `Validation error`,
                404: `User or transaction not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get transaction details
     * Get specific transaction by ID
     * @returns TransactionResponse Successful Response
     * @throws ApiError
     */
    public static getTransactionDetailsApiTransactionsTransactionIdDetailsGet({
        transactionId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        transactionId: string,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<TransactionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transactions/{transaction_id}/details',
            path: {
                'transaction_id': transactionId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `User or transaction not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Validate transaction data
     * Validate transaction data before processing
     * @returns any Successful Response
     * @throws ApiError
     */
    public static validateTransactionApiTransactionsValidatePost({
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        requestBody: TransactionCreateRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/transactions/validate',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `User or transaction not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Recalculate user balance
     * Recalculate user balance from transaction history
     * @returns any Successful Response
     * @throws ApiError
     */
    public static recalculateUserBalanceApiTransactionsRecalculateBalanceTelegramIdPost({
        telegramId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/transactions/recalculate-balance/{telegram_id}',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `User or transaction not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
}
